
import { BaseAtlasRequest } from "../BaseAtlasRequest";

interface PasswordResetData{
    email: string
}

export class GetPasswordResetUrl extends BaseAtlasRequest{
    public operationName: string = "getpasswordreseturl";
    body: PasswordResetData;

    constructor(email: string){
        super()
        this.body = {email: email};
    }
}





